"use strict";
/*!
 *
 * app.js
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("polyfill");
global.Promise = require('es6-promise').Promise;
require("picturefill");
/*** node_modules **/
require("jquery.easing");
require("slick-carousel");
/*** ./modules **/
var hasher_1 = __importDefault(require("hasher"));
var linker_1 = __importDefault(require("linker"));
var slide_scroll_1 = __importDefault(require("slide-scroll"));
require("@fancyapps/fancybox");
var page2top_1 = __importDefault(require("page2top"));
// import NavCurrent from 'nav-current';
var object_fit_images_1 = __importDefault(require("object-fit-images"));
require("expander");
var header_1 = __importDefault(require("header"));
require("swipe-elem");
var menu_1 = __importDefault(require("menu"));
var local_1 = __importDefault(require("local"));
hasher_1.default();
$(function () {
    new page2top_1.default();
    new linker_1.default({
        extendLink: '.sw-ExtendLink'
    });
    new header_1.default();
    new menu_1.default();
    // telHandler();
    slide_scroll_1.default({
        easing: 'easeOutExpo',
        speed: 700,
        not: '.sw-NotScroll, .sw-Modal'
    });
    $('.sw-Modal').fancybox({
        animationDuration: 700,
        transitionDuration: 700,
        arrows: true,
        infobar: false,
        smallBtn: true,
        toolbar: false,
        // buttons: ['close'],
        idleTime: 999999,
        wheel: false,
        touch: true
    });
    $('.sw-Swipe').swipeElem({
        width: 500
    });
    // $('.c-Grid.-col-2').fitHeight({
    // 	target: [],
    // 	column: 2,
    // 	responsive: {
    // 		largeDesktop: 2,
    // 		desktop: 2,
    // 		tablet: 2,
    // 		phone: 1
    // 	}
    // })
    if (location.pathname.match(/^\/contact\//)) {
        $('.st-Contact_Item.-contact').hide(0);
    }
    ;
    new local_1.default();
    $('.c-Pagination_Item.-disabled, .news-Footer_Prev.-disabled, .news-Footer_Next.-disabled').on('click', function (e) {
        e.preventDefault();
    });
    // $('.c-Tab').tab();
    object_fit_images_1.default('img.sw-ObjectFit', { watchMQ: true });
});
